import React, { FC, memo } from 'react'

import styled from 'styled-components'

const Container = styled.div<{ size: 's' | 'm'; isLightBackground: boolean }>`
  position: relative;
  height: ${({ size }) => (size === 's' ? '2.86rem' : '3.56rem')};
  display: flex;
  background: ${props => (props.isLightBackground ? 'rgba(226, 229, 234, 0.6)' : '#D6DBE1')};
  border-radius: ${({ size }) => (size === 's' ? '2.86rem' : '3.56rem')};
`

type Props = {
  size: 's' | 'm'
  children: React.ReactNode
  isLightBackground?: boolean
  className?: string
}

export const Tabs: FC<Props> = memo(({ size, className, isLightBackground = false, children }) => {
  return (
    <div className={className}>
      <Container size={size} isLightBackground={isLightBackground}>
        {children}
      </Container>
    </div>
  )
})
